import { render } from "./InputSkipSection.vue?vue&type=template&id=f17cd3ae&ts=true"
import script from "./InputSkipSection.vue?vue&type=script&lang=ts"
export * from "./InputSkipSection.vue?vue&type=script&lang=ts"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__